export default __webpack_public_path__ + "static/media/project1.ef8ff0ed.svg";